import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { Image } from '../components';

const containerBaseStyles = ({ theme }) => css`
  padding: 0 ${theme.spacings.zetta};
`;

const Container = styled('div')(containerBaseStyles);

const QuizImage = ({ cdnUrl, filename }) => (
  <Container>
    <Image src={`${cdnUrl}${filename}`} isSmall />
  </Container>
);

QuizImage.propTypes = {
  cdnUrl: PropTypes.string,
  filename: PropTypes.string,
};

QuizImage.defaultProps = {
  cdnUrl: 'https://hockeygame.s3.amazonaws.com/',
};

export default QuizImage;
